import React from 'react';

function MultiCheckboxComponent({ options, selected, onChange, fieldId, componentClass = "flex flex-col text-lg leading-6" }) {
  return (
    <div className={componentClass}>
      {options.map(option => (
        <label key={option.id} htmlFor={`checkbox_${fieldId}_${option.id}`} className="cursor-pointer flex items-center text-left checkbox mb-1">
          <input
            type="checkbox"
            id={`checkbox_${fieldId}_${option.id}`}
            name={option.name}
            data-default="false"
            data-filtername={option.name}
            value={option.field}
            checked={selected.includes(option.id)}
            onChange={() => onChange(option.id)}
            className="mr-2 hidden"
          />
          <i className={`fa-regular ${selected.includes(option.id) ? 'fa-square-check' : 'fa-square'}`} aria-hidden="true"></i>
          <span className="pl-2">
            {option.name}
          </span>
        </label>
      ))}
    </div>
  );
}

export default MultiCheckboxComponent;